<header class="header--page">
    <ul class="header__nav">
        <li>
            <h1>Business Unit</h1>
        </li>
    </ul>
</header>

<div class="mvd_container">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <div class="well mvd_container--pdf">
        <h2>Business Unit Selection</h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-5 mvd_form-group">
                    <label class="required" title="* Required">Business Unit</label>
                    <select class="mvd_form-control" autofocus [(ngModel)]="selectedBusinessUnit" (ngModelChange)="buChanged(selectedBusinessUnit)">
                        <option value="" selected="selected" *ngIf="businessUnitsLoading">Loading...</option>
                        <option value="">- Select -</option>
                        <optgroup label="{{location.name}}" *ngFor="let location of businessUnits">
                            <option value="{{businessUnit.id}},{{businessUnit.businessUnitName}},{{businessUnit.businessUnitTypeId}}" *ngFor="let businessUnit of location.businessUnits">{{businessUnit.businessUnitName}} ({{businessUnit.businessUnitTypeDisplayValue}})</option>
                        </optgroup>
                    </select>
                </div>

                <div class="col-sm-4 mvd_form-group" *ngIf="windowLoaded">
                    <label>Service Window</label>
                    <select class="mvd_form-control" [(ngModel)]="currentWindow">
                        <option value="" selected="selected">Optional...</option>
                        <option value="{{window.id}}" *ngFor="let window of windows">{{window.windowName}}</option>
                    </select>
                </div>
            </div>
        </fieldset>

        <div class="well__footer">
            <div class="btn--group">
                <button class="btn--default" name="button" (click)="cancelBusinessUnitSelection()">Cancel</button>
                <button class="btn--primary" name="button" [ngClass]="{disabled: businessUnitsLoading}" (click)="confirmBusinessUnit()">Confirm</button>
            </div>
        </div>
    </div>
</div>
